import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SidebarStore {
  isOpen: boolean;
  toggle: () => void;

  update: (isOpen: boolean) => void;
  pinned?: boolean;

  pin: (pinned: boolean) => void;
}

export const useHomeSidebarStore = create(
  persist<SidebarStore>(
    (set, get) => ({
      isOpen: false,
      toggle: () => {
        if (get().pinned && get().isOpen) {
          return;
        }

        set((state) => ({ isOpen: !state.isOpen }));
      },
      update: (isOpen) => {
        // if (!isOpen && get().pinned) {
        //   return;
        // }

        set({ isOpen });
      },
      pinned: false,
      pin: (pinned) => set({ pinned }),
    }),
    {
      name: "home-sidebar",
    },
  ),
);

export const useInboxSidebarStore = create(
  persist<SidebarStore>(
    (set, get) => ({
      isOpen: false,
      toggle: () => {
        if (get().pinned && get().isOpen) {
          return;
        }

        set((state) => ({ isOpen: !state.isOpen }));
      },
      update: (isOpen) => {
        // if (!isOpen && get().pinned) {
        //   return;
        // }

        set({ isOpen });
      },
      pinned: false,
      pin: (pinned) => set({ pinned }),
    }),
    {
      name: "inbox-sidebar",
    },
  ),
);
